import type { WithFlagsProps } from '@confluence/flags/entry-points/withFlags.ts';
import type { LoadableType } from '@confluence/loadable';
import { LoadableBackground } from '@confluence/loadable';
import type { UpFlowProps } from './UpFlow.tsx';

export const UpFlowCommerceRouterLoadable: LoadableType<
	Omit<UpFlowProps & WithFlagsProps, 'flags'>
> = LoadableBackground({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-UpFlowCommerceRouter" */ './UpFlowCommerceRouter.tsx'
			)
		).UpFlowCommerceRouter,
});
